import {
  GET_NOTIFICATIONS_SUCCEEDED,
  GET_NOTIFICATIONS_ERROR,
  LOADING_STATE,
  GET_MORE_NOTIFICATIONS_SUCCEEDED,
  GET_MORE_NOTIFICATIONS_ERROR,
  GET_UNREAD_NOTIFICATIONS_COUNT_SUCCEEDED,
  GET_UNREAD_NOTIFICATIONS_COUNT_ERROR
} from './types';

const INITIAL_STATE = {
  events: null,
  lastVisible: null,
  hasMore: false,
  unreadCount: 0,
  loading: false
};

export default function(state = INITIAL_STATE, action) {
  if (action.type === GET_NOTIFICATIONS_SUCCEEDED) {
    return { ...state, ...action.payload, loading: false };
  } else if (action.type === GET_NOTIFICATIONS_ERROR) {
    return { ...state, error: action.payload, loading: false };
  } else if (action.type === GET_MORE_NOTIFICATIONS_SUCCEEDED) {
    const { events, lastVisible, hasMore } = action.payload;
    return {
      ...state,
      events: [...state.events, ...events],
      lastVisible,
      hasMore
    };
  } else if (action.type === GET_MORE_NOTIFICATIONS_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === GET_UNREAD_NOTIFICATIONS_COUNT_SUCCEEDED) {
    return { ...state, unreadCount: action.payload };
  } else if (action.type === GET_UNREAD_NOTIFICATIONS_COUNT_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === LOADING_STATE) {
    return { ...state, loading: true };
  } else {
    return state;
  }
}
